module.exports = __webpack_public_path__ + "static/media/435_LivingRoom.b222ca08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_LivingRoom.jpg
// module id = 564
// module chunks = 0